Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
};
Date.prototype.addMinutes = function (m) {
  this.setMinutes(this.getMinutes() + m);
  return this;
};


export function setAuthClient(state, client) {
  state.client = client;
}

export function setAccessToken(state, token) {
  const exp = new Date().addHours(12);
  localStorage.setItem("access_token", token);
  localStorage.setItem("access_token_expires", exp);

  state.accessToken = token;
  state.tokenExpires = exp;
}

export function setUser(state, user) {
  localStorage.setItem("user", JSON.stringify(user));

  state.user = user;
}

export function logout(state) {
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");

  state.accessToken = null;
  state.user = null;
}